import { createContext, useContext } from "react";

import { MenuEditorState } from "features/MenuEditor/hooks/useMenuEditorState";

export const MenuEditorContext = createContext<MenuEditorState | null>(null);

export const useMenuEditorContext = (): MenuEditorState => {
    const context = useContext(MenuEditorContext);

    if (!context) {
        throw new Error("useMenuEditorContext должен использоваться внутри MenuEditor");
    }

    return context;
};
